<!--Pagination-->
<nav aria-label="pagination example" *ngIf="total">
  <div class="d-flex justify-content-between">
    <div class="d-flex align-items-center">
      <span class="mr-2">Số lượng hiển thị</span>
      <select [(ngModel)]="size" (ngModelChange)="changeSize()" class="form-control" style="width: 100px;">
        <option *ngFor="let item of sizes" [value]="item.size">{{item.name}}</option>
      </select>
      <span class="ml-2">Hiện {{startItem}} - {{endItem}} trong số {{total}}</span>
    </div>
    <ul class="pagination pg-blue justify-content-end">
      <!--Arrow left-->
      <li class="page-item" *ngIf="totalPage <= 5">
        <span class="page-link" (click)="totalPage > 1 && first()">
          <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3.24316 5.50049L8.74267 0.000976803L9.89441 1.15271L5.54661 5.50049L9.89441 9.84826L8.74267 11L3.24316 5.50049Z"
              fill="#828282" />
            <rect x="1.5" y="11" width="1.5" height="11" transform="rotate(-180 1.5 11)" fill="#828282" />
          </svg>
        </span>
      </li>
      <li class="page-item" *ngIf="totalPage > 5" [ngClass]="selectedPage === 1 ? 'disabled-button' : ''">
        <span class="page-link" (click)="changePage(selectedPage - 5)">
          <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3.24316 5.50049L8.74267 0.000976803L9.89441 1.15271L5.54661 5.50049L9.89441 9.84826L8.74267 11L3.24316 5.50049Z"
              fill="#828282" />
            <rect x="1.5" y="11" width="1.5" height="11" transform="rotate(-180 1.5 11)" fill="#828282" />
          </svg>
        </span>
      </li>
      <li class="page-item">
        <span class="page-link" [ngClass]="!checkPrevious() ? 'disabled-button' : ''" (click)="previous()">
          <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M-2.40391e-07 5.50049L5.49951 0.000976803L6.65125 1.15271L2.30345 5.50049L6.65125 9.84826L5.49951 11L-2.40391e-07 5.50049Z"
              fill="#828282" />
          </svg>
        </span>
      </li>
      <li class="page-item" *ngFor="let item of pages; index as index">
        <span class="page-link" (click)="changePage(item)"
          [ngClass]="item === selectedPage ? 'active-link background-active-link' : ''">
          {{item}}
          <span class="sr-only">(current)</span>
        </span>
      </li>
      <li class="page-item">
        <span class="page-link" [ngClass]="!checkNext() ? 'disabled-button' : ''" (click)="next()">
          <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.65137 5.50049L1.15186 11L0.000119881 9.84826L4.34792 5.50049L0.000119984 1.15271L1.15186 0.000976179L6.65137 5.50049Z"
              fill="#828282" />
          </svg>
        </span>
      </li>
      <li class="page-item" *ngIf="totalPage > 5" [ngClass]="selectedPage === totalPage ? 'disabled-button' : ''">
        <span class="page-link" (click)="changePage(selectedPage + 5)">
          <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.25684 5.49951L1.75733 10.999L0.605588 9.84729L4.95339 5.49951L0.605588 1.15174L1.75732 2.40391e-07L7.25684 5.49951Z"
              fill="#828282" />
            <rect x="9" width="1.5" height="11" fill="#828282" />
          </svg>
        </span>
      </li>
      <li class="page-item" *ngIf="totalPage <= 5">
        <span class="page-link" (click)="totalPage > 1 && last()">
          <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.25684 5.49951L1.75733 10.999L0.605588 9.84729L4.95339 5.49951L0.605588 1.15174L1.75732 2.40391e-07L7.25684 5.49951Z"
              fill="#828282" />
            <rect x="9" width="1.5" height="11" fill="#828282" />
          </svg>
        </span>
      </li>
    </ul>
  </div>
  
</nav>